<template>
  <div class="teacher_wrap">
    <div v-if="showProfile&&showTab&&tabs.length" class="column-filter-wrapper" :class="{'show': showColumnFilter}">
      <div class="tab">
        <div class="tabs">
          <div v-for=" (item,index) in tabs" :key="index" :class="`tab-item ${activeName===item.name?'is-active':''}`" @click="handleChange(item)">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="profile-and-courses wrapper">
      <template v-if="!profileInfo.teacherId||!doneLoad">
        <Loading :show="initLoading" />
      </template>
      <template v-else-if="profileInfo.teacherId && profileInfo.state == 0">
        <div class="card_wrap">
          <TeacherIndexContent :teacher="profileInfo" />
        </div>
        <div v-if="showTab" class="tab">
          <div v-if="tabs.length&&showProfile" class="tabs">
            <div v-for=" (item,index) in tabs" :key="index" :class="`tab-item ${activeName===item.name?'is-active':''}`" @click="handleChange(item)">
              {{ item.title }}
            </div>
          </div>
          <div v-if="doneLoad">
            <ProfileContent id="Profile" :teacher-id="teacherId" :profile-info="profileInfo" />
            <TeacherCoursesList v-show="teacherCoursesListLength" id="Courses" :teacher-id="teacherId" @listLength="getCourse" />
          </div>
        </div>
      </template>
      <template v-else>
        <Exception class="teacher-detail-exception-wrapper wrapper" :tip-text="exceptionTipText" placeholder-class-name="system-error-img" :show-retry-btn="true" :retry-btn-text="retryBtnText" @retry="showMoreTeacherInfo" />
      </template>
    </div>
  </div>
</template>
<script>
import skrollTop from 'skrolltop';
import Loading from 'components/common/Loading/index.vue'
import Exception from 'components/common/Exception';
import TeacherIndexContent from 'components/teacher/TeacherIndexContent/index.vue'
import ProfileContent from 'components/teacher/ProfileContent/index.vue'
import TeacherCoursesList from 'components/teacher/TeacherCoursesList/index.vue'
import { oneApi } from 'config/api'

import { isInView } from 'common/utils'

const throttle = require('lodash/throttle');

export default {
  components: {
    TeacherIndexContent, Loading, ProfileContent, TeacherCoursesList, Exception,
  },
  props: {
    teacherId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      teacherCoursesListLength: 0,
      isCheckActived: true,
      showColumnFilter: false,
      doneLoad: false,
      showTab: false,
      tabs: [],
      showCourse: false,
      profileInfo: {},
      initLoading: true,
      activeName: 'Profile',
      exceptionTipText: this.$t('teacher.teacherDisableText'),
      retryBtnText: 'View more teachers',
    }
  },
  computed: {
    showProfile() {
      return this.profileInfo && (this.profileInfo.videoUrl || (this.profileInfo.achievementList && this.profileInfo.achievementList.length) || this.profileInfo.experience)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.queryTeacherProfile({
        callback: () => {
          this.initLoading = false;
        },
      })
    })
    this.addScrollEvent()
  },
  created() {
    this.getCourse();
  },
  destroyed() {
    this.removeScrollEvent()
  },
  methods: {
    // 添加滚动事件
    addScrollEvent() {
      window.addEventListener('scroll', this.watchScroll, false);
    },
    // 移除滚动事件
    removeScrollEvent() {
      window.removeEventListener('scroll', this.watchScroll, false);
    },
    watchScroll: throttle(function watchScrollFun() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      this.showColumnFilter = scrollTop >= 540
      if (!this.isCheckActived) return
      // 设置当前选中tab
      for (let i = 0; i < this.tabs.length; i += 1) {
        if (isInView(`${this.tabs[i].title}`)) {
          this.activeName = this.tabs[i].title
          return
        }
      }
    }),
    scrollIntoView(id) {
      const ele = document.getElementById(id)
      if (ele) {
        this.isCheckActived = false
        const that = this
        skrollTop.scrollTo({
          to: ele.offsetTop - 200,
          duration: 300,
          callback() {
            setTimeout(() => {
              that.isCheckActived = true
            }, 500)
          },
        });
      }
    },
    getCourse(val) {
      this.teacherCoursesListLength = val
      this.showTab = false;
      if (val && val > 0) {
        this.tabs = this.$t('teacher.detailTabs')
      } else {
        this.tabs = [];
      }
      this.doneLoad = true;
      this.showTab = true;
    },
    handleBack() {
      this.$router.back()
    },
    changeScroll() {
      document.body.scrollTop = 0
    },
    backToDetail() {
      this.$router.back()
    },
    async queryTeacherProfile({ callback }) {
      const data = {
        teacherId: this.teacherId,
      }
      const res = await this.$axios.post(oneApi.queryTeacherProfile, data, { rewritePostBody: true })
      if (Number(res.code) !== 0) {
        this.$ElMessage.error(res.msg);
        return
      }
      this.profileInfo = res.data;
      // 动态生成标题和描述
      const teacher = this.profileInfo;
      const title = `${this.$store.state.website.page.title}${teacher.name}`;
      const keywords = teacher?.highlightList.join() || '';
      const description = teacher?.achievementList.join() || '';
      const seoParams = {
        description,
        title,
        keywords,
        isDefault: '',
      };
      this.$store.dispatch('website/updatePageData', seoParams);
      this.teacherDetailPv(this.profileInfo)
      if (callback) callback()
    },
    handleChange(tab) {
      this.scrollIntoView(tab.name)
      this.activeName = tab.name
    },
    showMoreTeacherInfo() {
      this.$router.push('/teachers')
    },
    teacherDetailPv(teacher) {
      this.Sensors.track('teacher_detail_pv', {
        content_teacher: teacher.name,
      })
    },
  },
}
</script>
<style lang="scss">
.teacher_wrap {
  background: rgba(244, 246, 250, 1);

  .tabs {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;

    .tab-item {
      cursor: pointer;
      width: 306px;
      text-align: center;
      outline: none !important;
      font-size: 22px;
      font-weight: 600;
      color: var(--txt-color-lv2);
      line-height: 24px;
      height: 24px;

      &.is-active {
        color: rgba(23, 43, 77, 1);

        &::after {
          display: block;
          content: '';
          width: 146px;
          height: 2px;
          background: #222;
          margin: 25px auto 0;
        }
      }

      &:nth-last-child(1) {
        border-left: #dee2e7 2px  solid;
      }
    }
  }

  .column-filter-wrapper {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    height: 80px;
    background: rgba(255, 255, 255, 0.95);
    z-index: 9;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);

    &.show {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
      box-shadow: 0 -6px 23px 9px rgba(162, 170, 184, 0.06);
    }
  }

  .teacher-detail-exception-wrapper {
    padding: 100px 0;
  }

  .profile-and-courses {
    margin: 0 auto;
    padding: 40px 0 120px;
    background: rgba(244, 246, 250, 1);
    border-radius: 10px;

    .card_wrap {
      display: flex;
      justify-content: space-around;

      .teacher-info {
        box-shadow: none;

        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 40px;
          width: 310px;
          overflow: visible;

          .teacher-subject {
            display: block;
            overflow: visible;
            font-size: 18px;
          }

          .teacher-tags-list {
            padding-top: 26px;
            .tag-item { max-width: max-content; }
          }
        }
      }
    }
  }
}
</style>
